import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Capture the install prompt globally so pages can render the CTA
if (typeof window !== 'undefined' && !window.__typortalHasBipListener) {
  window.__typortalHasBipListener = true;
  window.__typortalInstallPrompt = null;
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    window.__typortalInstallPrompt = e;
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (!registration || !registration.waiting || typeof window === 'undefined') return;

    const waitingWorker = registration.waiting;
    waitingWorker.postMessage({ type: 'SKIP_WAITING' });

    // When the new SW takes control, reload to get fresh assets/manifest
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      window.location.reload();
    });
  }
});
